import { useMemo } from 'react';

import { EFFECT_DEFAULT_VALUE } from 'constants/params';
import { ConfigFlags } from 'services/file.service';
import { useAppSelector } from 'store/store-hooks';
import { CssFilter } from './use-css-filter';

export const useCssFilterFile = (key: keyof CssFilter, fileId: FileId): number => {
  const selectedFile = useAppSelector((state) => state.projects.selectedFile);
  const adjustment = useAppSelector((state) => state.editor.effectsAdjustment);
  const configs = useAppSelector((state) => state.app__files.configs);
  const configPanel = useAppSelector((state) => state.editor.configPanel);
  const isActive = selectedFile === fileId;

  const fileData = useMemo(() => {
    return configs[fileId];
  }, [configs, fileId]);

  const isAdjustment = useMemo(() => {
    if (!fileData) return;
    if (isActive && fileData.flags.includes(ConfigFlags[key]) && configPanel === 'file') return true;
  }, [fileData, isActive, configPanel]);

  return useMemo(() => {
    if (!fileData) return EFFECT_DEFAULT_VALUE;
    if (isAdjustment) return adjustment[key];
    if (fileData.flags.includes(ConfigFlags[key])) return fileData[key];
    return EFFECT_DEFAULT_VALUE;
  }, [fileData, isAdjustment && adjustment]);
};
